import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { useRegisterSW } from 'virtual:pwa-register/react'

export default function PWAReloadPrompt() {
    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker
    } = useRegisterSW()

    useEffect(() => {
        if (offlineReady) {
            toast.success('App ready to work offline', { duration: 3000 })
            setOfflineReady(false)
        }
    }, [offlineReady, setOfflineReady])

    useEffect(() => {
        if (!needRefresh) return
        toast(
            (t) => (
                <span className="flex items-center gap-3">
                    <span>A new version is available.</span>
                    <button
                        type="button"
                        onClick={() => {
                            toast.dismiss(t.id)
                            void updateServiceWorker(true)
                        }}
                        className="rounded-md px-2.5 py-1 text-[12px] font-semibold text-white"
                        style={{ background: 'var(--color-gold-500)' }}
                    >
                        Reload
                    </button>
                </span>
            ),
            { duration: Infinity, id: 'pwa-update' }
        )
        setNeedRefresh(false)
    }, [needRefresh, setNeedRefresh, updateServiceWorker])

    return null
}
